import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../hooks/redux-hooks";
import { register } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handleRegister = async () => {
    setNameError("");
    setEmailError("");
    setPasswordError("");

    let hasError = false;

    if (!name) {
      setNameError(t("errNameRequired"));
      hasError = true;
    }
    if (!email) {
      setEmailError(t("errEmailRequired"));
      hasError = true;
    }
    if (!password) {
      setPasswordError(t("pleaseInputPassword"));
      hasError = true;
    }

    if (!hasError) {
      try {
        await dispatch(register({ name, email, password })).unwrap();
        dispatch(
          showNotification({
            message: t("registerSuccess"),
            type: NotificationType.Success,
          })
        );
        navigate("/login");
      } catch (error: any) {
        // 处理后端返回的具体错误
        if (error.field === 'email') {
          setEmailError(error.message);
        } else if (error.field === 'password') {
          setPasswordError(error.message);
        } else {
          setNameError(error.message);
        }
      }
    }
  };

  return (
    <>
      <Container maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            mt: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.light" }}>
            <LockOutlined />
          </Avatar>
          <Typography variant="h5">{t("registerUser")}</Typography>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  name="name"
                  required
                  fullWidth
                  id="name"
                  label={t("name")}
                  autoFocus
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={!!nameError}
                  helperText={nameError}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label={t("emailAddress")}
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!emailError}
                  helperText={emailError}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label={t("password")}
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  error={!!passwordError}
                  helperText={passwordError}
                />
              </Grid>
            </Grid>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleRegister}
            >
              {t("register")}
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link to="/login">{t("backToLogin")}</Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Register;
